module.exports = __webpack_public_path__ + "img/thumb_2018-01.4d1b4261.jpg";